class Socket {

	constructor(options = {}) {

		if (!options.scope || !options.scope_id) {
			throw new Error('Missing the required "scope" and "scope_id" parameters.');
		}

		if (window.Primus) {

			this.primus = new window.Primus(`?scope=${options.scope}&scope_id=${options.scope_id}`);

			console.info('created a new Socket instance!');

		} else {

			console.info('Error: Missing the "window.Primus" object!');

		}

	}

	static getInstance(options = {}) {

		// Server-side rendering: there is no socket (and the singleton must not
		// be shared across requests). Callers already handle a missing socket;
		// constructing one here only threw on `window` and logged a stack
		// trace for every SSR request.
		if (typeof window === 'undefined') {
			return undefined;
		}

		if (!Socket.instance) {

			console.info('missing Socket instance...');

			try {

				Socket.instance = new Socket(options);

			} catch (error) {
				console.error(error);
			}

		}

		return Socket.instance;

	}

	/**
	 * Adds an event listener for a primus action.
	 *
	 * @param {string} action  The action to listen for.
	 * @param {func} cb        The callback function.
	 */
	on(action, cb) {

		if (this.primus) {
			this.primus.on(action, cb);
		}

	}

	/**
	 * Removes an event listener for a primus action.
	 *
	 * @param {string} action  The action to remove the listener for.
	 * @param {func} cb        The callback function.
	 */
	removeListener(action, cb) {

		if (this.primus) {
			this.primus.removeListener(action, cb);
		}

	}

}

export default Socket;
